import { useEffect, useState } from 'react';

/**
 * `false` on the render that mounts the component, `true` on every later one.
 *
 * PSTUDIO-4241. It exists for live regions that appear WITH the thing they
 * describe — a loading overlay, a Suspense fallback. A node carrying
 * `role="status"` that enters the document already holding its text is
 * announced inconsistently: the region and its content arrive in one mutation,
 * and a reader that only watches for changes INSIDE a known region has nothing
 * to compare against. Rendering the region empty first and filling it on the
 * next pass turns the announcement into an ordinary content change, which is
 * the case every reader handles.
 *
 * The same reasoning is why `pages/builder.tsx` keeps its own region mounted
 * permanently — that one can also announce the END of loading, which a region
 * living inside the loader cannot, because it unmounts with it.
 *
 * Not enough when the region mounts on a DISCRETE update (a click): React
 * flushes that update's passive effects before paint, so the empty pass may
 * never reach the screen. `CollabConnectionAnnouncer` waits on a timer for
 * that reason (PSTUDIO-4449).
 *
 * Idempotent under React 18's StrictMode replay: the effect writes the same
 * value, so the second setup is a no-op re-render React drops.
 */
export function useLiveRegionReady(): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  return ready;
}
